import { Injectable } from '@angular/core';
import {
  calculateStartingPixel,
  GanttActivityPixelCalculationInput,
} from './calculate-left-right-pixel.fn';

@Injectable({
  providedIn: 'root',
})
export class GanttShiftPixelLengthService {
  calculate({
    startTime,
    endTime,
    frameLength,
    dayCount,
    timeframe,
  }: GanttActivityPixelCalculationInput): number {
    const rightPixel = calculateStartingPixel({
      startTime: endTime,
      frameLength,
      dayCount,
      timeframe,
    });

    const leftPixel = calculateStartingPixel({
      startTime,
      frameLength,
      dayCount,
      timeframe,
    });
    return rightPixel - leftPixel;
  }
}
